module.exports = {
  "wrapper": {
    "overflow": "hidden",
    "position": "relative"
  },
  "fake-border": {
    "height": "1",
    "position": "absolute",
    "bottom": "1",
    "left": 0
  },
  "cell-margin": {
    "marginBottom": "16"
  },
  "dof-cell-highlight": {
    "backgroundColor:active": "#f4f5f6"
  },
  "dof-cell": {
    "display": "flex",
    "flexDirection": "row",
    "flex": 1
  },
  "cell-wrapper": {
    "flex": 1
  },
  "mgb-1": {
    "marginBottom": "1"
  },
  "cell-disabled-opacity": {
    "opacity": 0.3
  },
  "cell-abled-opacity": {
    "opacity": 1
  },
  "left": {
    "justifyContent": "center"
  },
  "circle-bg": {
    "marginLeft": "32",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "overflow": "hidden"
  },
  "text-dot-tip": {
    "width": "16",
    "height": "16",
    "borderRadius": "10",
    "backgroundColor": "#f56428",
    "justifyContent": "center",
    "alignItems": "center",
    "textAlign": "center",
    "marginLeft": "22"
  },
  "dot-tip": {
    "position": "absolute",
    "top": "30",
    "right": "12",
    "width": "16",
    "height": "16",
    "borderRadius": "10",
    "backgroundColor": "#f56428"
  },
  "dot-num-tip": {
    "position": "absolute",
    "fontSize": "24",
    "top": "30",
    "right": "32",
    "borderRadius": "100",
    "backgroundColor": "#f56428",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingLeft": "8",
    "paddingRight": "8",
    "lineHeight": 1
  },
  "dot-num-tip-text": {
    "fontSize": "24",
    "color": "#ffffff"
  },
  "main-container": {
    "flex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "marginLeft": "32",
    "overflow": "hidden"
  },
  "Dotleft32": {
    "marginLeft": "32"
  },
  "Dotright32": {
    "marginRight": "32"
  },
  "notDot": {
    "marginLeft": "0"
  },
  "dotRight": {
    "right": "32"
  },
  "dotTopMax": {
    "top": "34"
  },
  "dotTopMedium": {
    "top": "39"
  },
  "dotTopBig": {
    "top": "44"
  },
  "dotTopMin": {
    "top": "54"
  },
  "cell-label-text": {
    "fontSize": "30",
    "color": "#616c73",
    "width": "188",
    "marginRight": "10"
  },
  "middle": {
    "flex": 1,
    "minHeight": "124",
    "overflow": "hidden"
  },
  "has-desc": {
    "minHeight": "160",
    "justifyContent": "center"
  },
  "no-desc": {
    "justifyContent": "center"
  },
  "cell-title-wrapper": {
    "flexDirection": "row",
    "marginRight": "40",
    "overflow": "hidden"
  },
  "cell-title-content": {
    "flex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "overflow": "hidden"
  },
  "title-flex-expand": {
    "flex": 1
  },
  "cell-title": {
    "flex": 1,
    "flexDirection": "row",
    "alignItems": "center"
  },
  "avatar-icon": {
    "width": "40",
    "height": "40",
    "borderRadius": "20",
    "marginRight": "24"
  },
  "cell-title-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "color": "#1e2e37",
    "lines": 1,
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "cell-title-tag": {
    "width": "88",
    "height": "48",
    "justifyContent": "center",
    "alignItems": "center",
    "textAlign": "center",
    "backgroundColor": "#f2f2f2",
    "borderRadius": "48",
    "marginLeft": "18"
  },
  "cell-title-tag-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "24",
    "color": "#616c73"
  },
  "cell-desc-wrapper": {
    "marginTop": "16"
  },
  "margin-top-24": {
    "marginTop": "18"
  },
  "cell-desc-text": {
    "fontFamily": "PingFangSC-Regular",
    "color": "#8e969b",
    "fontSize": "24",
    "lines": 2,
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "right-tip-wrapper": {
    "paddingTop": "40",
    "paddingRight": "32",
    "paddingBottom": 0,
    "paddingLeft": 0
  },
  "space-gap": {
    "marginLeft": "92"
  },
  "right-tip-text": {
    "fontFamily": "PingFangSC-Regular",
    "color": "#8e969b",
    "fontSize": "24",
    "textAlign": "right"
  },
  "right": {
    "flexDirection": "row",
    "alignItems": "center",
    "paddingRight": "24",
    "paddingLeft": "32"
  },
  "has-no-padding-left": {
    "paddingRight": 0,
    "paddingLeft": 0
  },
  "right-text": {
    "fontFamily": "PingFangSC-Regular",
    "color": "#8e969b",
    "fontSize": "28",
    "letterSpacing": 0,
    "textAlign": "right"
  },
  "arrow-wrapper": {
    "paddingLeft": "0"
  },
  "cell-arrow-icon": {
    "width": "40",
    "height": "40"
  },
  "midea-swipe-cell__right": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#f56428",
    "fontSize": "32",
    "color": "#ffffff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-25ecf10a!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-cell/index.vue
// module id = 444
// module chunks = 0 1